export { Tooltip } from './Tooltip';
export type { TooltipProps, Placement } from './Tooltip';
